import { Component, Input, OnInit } from '@angular/core';
import { StatusValidation } from 'src/app/models/kyc';

@Component({
  selector: 'app-kyc-status',
  templateUrl: './kyc-status.component.html',
  styleUrls: ['./kyc-status.component.scss']
})
export class KycStatusComponent implements OnInit {

    @Input() validation: StatusValidation;
    @Input() statusId: number;

    constructor() { }

    ngOnInit() {
    }

}
